import { memo, useState } from 'react';
import { connect } from 'react-redux';
import { Form, FormInput } from 'shards-react';
import { useRequestHook } from 'utils/hooks/hooks';
import { addDocumentInRedux } from 'utils/redux/actions';

const SearchDocumentById = ({ dispatch, savedDocument, docTypesList, toggleModal, serviceID, serviceType, displayReference }) => {
  const { handleRequest } = useRequestHook();
  const [searchedId, setSearchedId] = useState('');
  const [isInvalid, setIsInvalid] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const updateSearchField = (e) => {
    if (isInvalid) setIsInvalid(false);

    return setSearchedId(e.target.value);
  };

  const searchDocumentById = (e) => {
    e.preventDefault();

    if (searchedId !== savedDocument?.id) {
      setIsloading(true);

      return handleRequest(
        'post',
        '/documents/load-selected-document',
        {
          documentId: searchedId,
          pagesToRequest: [0],
          serviceType,
          displayReference,
          serviceID,
          docTypesList,
        },
        (response) => {
          setIsloading(false);
          setSearchedId('');

          if (!response) return setIsInvalid(true);

          dispatch(addDocumentInRedux(response));
          toggleModal();
        }
      );
    }

    setSearchedId('');

    return toggleModal();
  };

  return (
    <Form onSubmit={(e) => searchDocumentById(e)}>
      <FormInput className='manual-search' type='search' required spellCheck='false' placeholder='Dokument manuell öffnen' invalid={isInvalid} disabled={isloading} value={searchedId} onChange={(e) => updateSearchField(e)} />
    </Form>
  );
};

/**
 * Take the id of saved in redux document and return it
 * in components props.
 */
const mapStateToProps = ({ savedDocument, docTypesList }) => ({
  savedDocument,
  docTypesList,
});

export default connect(mapStateToProps)(memo(SearchDocumentById));
